import TagSelectDialog from './TagSelectDialog'
import TagList from './../../api/TagList'

export default {
	name: 'TagView',
	props: {
		value: {
			type: Array,
		},
		slugs: {
			type: [Array, null],
			default: null
		},
		excludes: {
			type: [Array, null],
			default: null
		}
	},
	data() {
		return {
			dialogOpen: false,
			items: [],
			selectedItems: [],
		}
	},
	components: {
		TagSelectDialog,
	},
	template: `
		<div class="tag-select-container">
			<span class="page-tag page-tag-sm selected"
				v-for="item in selectedItems"
			>
				{{item.name}}
			</span>
			<button type="button" class="btn btn-default btn-block btn-sm"
				@click="openDialog"
			>
				編集
			</button>
			<TagSelectDialog
				v-if="dialogOpen"
				:value="value"
				:slugs="slugs"
				:excludes="excludes"
				@input="onInput"
				@cancel="closeDialog"
			/>
		</div>
	`,
	mounted() {
		TagList.get().then(items => {
			this.items = items
		})
	},
	methods: {
		onInput(value) {
			this.$emit('input', value)
			this.closeDialog()
		},
		openDialog() {
			this.dialogOpen = true
		},
		closeDialog() {
			this.dialogOpen = false
		},
		updateCurrentItem() {
			this.selectedItems = this.items.filter(item => this.value.some(val => val === item.id))
		},
	},
	watch: {
		items() {
			this.updateCurrentItem()
		},
		value() {
			this.updateCurrentItem()
		},
	},
}
